import { useState, useEffect } from 'react';

interface SlackNotificationState {
  isVisible: boolean;
  demoIndex: number;
}

export const useSlackNotifications = () => {
  const [notification, setNotification] = useState<SlackNotificationState>({
    isVisible: false,
    demoIndex: 0
  });

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Listen for Cmd/Ctrl + number (1-9)
      if ((event.metaKey || event.ctrlKey) && event.key >= '1' && event.key <= '9') {
        event.preventDefault();
        const demoIndex = parseInt(event.key) - 1; // Convert 1-9 to 0-8
        
        setNotification({
          isVisible: true,
          demoIndex
        });
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const showNotification = (demoIndex: number) => {
    setNotification({
      isVisible: true,
      demoIndex
    });
  };

  const hideNotification = () => {
    setNotification(prev => ({
      ...prev,
      isVisible: false
    }));
  };

  return {
    notification,
    showNotification,
    hideNotification
  };
};
